export const COMPONENT = {
  STATUS_CARDS: 'StatusCards',
  EVENT_LIST: 'eventList',
  EVENT_TYPES: 'EventTypes',
};

export const GA = {
  category: 'Feed',
  events: {
    eventTypeClicked: 'Widget Reminder Event type clicked',
    eventAddClicked: 'Widget Reminder Event Add clicked',
    scheduleAddClicked: 'Widget Reminder Add schedule clicked',
  },
};
